import config from '../../config';
import { authHeader } from '../_helpers/auth-header';
import { createRequestCache } from '../Page/HomePage/floorDeckRequestCache';

const cache = createRequestCache(30000);

async function request(path, method = 'GET', body) {
    const response = await fetch(`${config.apiUrl}/machine-settings${path}`, {
        method,
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json();

    if (!response.ok) {
        const error = new Error(data.error || data.message || 'Unable to load machines.');
        error.status = response.status;
        throw error;
    }

    return data;
}

function read(path, force) {
    // Keep data and in-flight requests isolated when the signed-in user changes.
    const key = JSON.stringify([authHeader().Authorization, path]);
    const loader = () => request(path);

    return force
        ? { data: cache.peek(key), revalidate: cache.get(key, loader, true) }
        : cache.getStaleWhileRevalidate(key, loader);
}

async function mutate(path, method, values) {
    cache.clear();
    
    try {
        return await request(path, method, values);
    } finally {
        cache.clear();
    }
}

// The server always uses the signed-in user's own company.
export const machineSettingsService = {
    list: (force = false) => read('', force),
    categories: (force = false) => read('/categories', force),
    createCategory: values => mutate('/categories', 'POST', values),
    updateCategory: (id, values) => mutate('/categories/' + encodeURIComponent(id), 'PUT', values),
    create: values => mutate('', 'POST', values),
    update: (id, values) => mutate('/' + encodeURIComponent(id), 'PUT', values),
    deactivate: id => mutate('/' + encodeURIComponent(id), 'DELETE'),
    clear: () => cache.clear(),
};
